module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-circle-fill-29bddcce.svg";